import React, { Component } from 'react';
import Comments from '../comments/Comments'

//styles
import './article.scss';

import '../../static/fonts/opensanshebrew/stylesheet.css'
import '../../static/fonts/NarkisBlockCondensed/style.css'
import { ArticlesApi, CommentsApi } from '../../API/api'
import Header from '../Header/Header';
import Loader from '../Loader/Loader';
import '../../static/_reset.scss'
import { fpInit } from '../../static/player'
import { GA_Event, VirtualPageview, Prof, Uri } from '../Analytics/Analytics'

class Article extends Component {
    constructor() {
        super();
        this.setAllComments = this.setAllComments.bind(this);
        this.toggleLoader = this.toggleLoader.bind(this);

        this.state = {
            articleHtml: "",
            showArticleLoader: true,
            comments: [],
            commentCount: 0,
            loaderState: false
        }
    }

    async componentDidMount() {
        this.toggleLoader(true);
        let articleId = this.props.router.match.params.article;
        VirtualPageview(Uri + articleId + Prof);
        let commentId = this.props.router.match.params.comment;
        const _articleHtml = await ArticlesApi.get(articleId);
        this.setState({
            articleHtml: _articleHtml
        });

        const _comments = await CommentsApi.get(
            commentId,
            10
        )

        const _commentCount = await CommentsApi.getCount(commentId);
        this.setState({
            comments: _comments,
            commentCount: _commentCount,
            articleHtml: _articleHtml,
            showMoreCommentsState: 10 >= _commentCount ?
                "off" : "on",
            showArticleLoader: false,
            loaderState: false
        });
        window.scrollTo(0, 0);
        let videos = this.getVideosObject(_articleHtml);

        if (videos != null && videos.length > 0) {
            videos.map((video) => {
                this.initVideo({
                    videoId: video.videoId,
                    mainUrl: video.mainUrl,
                    poster: video.poster
                })
            });
        }


    }

    getVideosObject(html) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, "text/html");
        var scripts = doc.body.getElementsByTagName("script");
        var arr = [];
        for (let i = 0; i < scripts.length; i++) {
            if (scripts[i].innerText.indexOf("Video") > -1) {
                let str = scripts[i].innerText.substring(scripts[i].innerText.indexOf("{"), scripts[i].length);
                arr.push(JSON.parse(str.split("'").join("\"")));
            }
        }
        return arr;
    }

    initVideo(details) {
        fpInit(Object.assign({}, details, { selector: "#vid" + details.videoId }));
    }

    async setAllComments() {
        this.toggleLoader(true);
        const _comments = await CommentsApi.get(this.props.router.match.params.comment);

        this.setState({
            comments: _comments,
            showMoreCommentsState: 'off',
            loaderState: false
        });
    }

    toggleLoader(flag) {
        this.setState({ loaderState: flag })
    }
    render() {
        return (
            <div className="article-container">
                <Loader active={this.state.loaderState} />
                <Header isArticle={true} sendGA={GA_Event} />
                <div className="article">
                    <section className="section section-article">

                        <div className="padding">
                            <div className="container">
                                <div className="article-content" dangerouslySetInnerHTML={{ __html: this.state.articleHtml }}></div>
                            </div>
                        </div>
                    </section>
                </div>
                <Comments
                    comments={this.state.comments}
                    commentCount={this.state.commentCount}
                    showContainer={!this.state.showArticleLoader}
                    articleRef={this.props.router.match.params.comment}
                    onLoadMoreClick={this.setAllComments}
                    showMoreCommentsState={this.state.showMoreCommentsState}
                />

            </div>
        );
    }
}

export default Article;


// WEBPACK FOOTER //
// ./src/Components/Article/Article.js